/**
 * fix-kelly-0930-P0: mounts the cross-tab `keyCloak` watcher (see
 * accountSwitch.js::handleCrossTabKeyCloakChange for the full rationale).
 * Renders nothing — flag-gated the same way as every other Account Switcher
 * surface (ACCOUNT_SWITCHER_ENABLED), since this exists to protect the
 * multi-account registry that flag controls.
 */
import { useEffect } from "react";
import { ACCOUNT_SWITCHER_ENABLED } from "./accountSwitcherFlag";
import { handleCrossTabKeyCloakChange } from "../../services/accountSwitch";

export default function CrossTabSessionSync() {
  useEffect(() => {
    if (!ACCOUNT_SWITCHER_ENABLED) return undefined;
    const onStorage = (event) => handleCrossTabKeyCloakChange(event);
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return null;
}
